/* @flow */

export { CrossDomainSafeWeakMap as WeakMap } from './weakmap';



// WEBPACK FOOTER //
// ./node_modules/cross-domain-safe-weakmap/src/index.js